import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const UnverifiedPage = () => {
  const { logout, user } = useAuth0();

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-100 to-orange-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          <div className="mb-6">
            <div className="mx-auto w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
          </div>
          
          <h1 className="text-2xl font-bold text-gray-800 mb-4">Email Verification Required</h1>
          
          <p className="text-gray-600 mb-6">
            Please verify your email address to access the admin portal. 
            Check your inbox for a verification email from Auth0.
          </p>
          
          {user && (
            <p className="text-sm text-gray-500 mb-6">
              Verification email sent to: <strong>{user.email}</strong>
            </p>
          )}
          
          <div className="space-y-3">
            <button 
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition duration-200"
              onClick={() => window.location.reload()}
            >
              I've Verified My Email
            </button>
            
            <button 
              className="w-full bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-3 px-6 rounded-lg transition duration-200"
              onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
            >
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnverifiedPage; 